import { render, staticRenderFns } from "./ShowUpload.vue?vue&type=template&id=4021322e&scoped=true&"
import script from "./ShowUpload.vue?vue&type=script&lang=ts&"
export * from "./ShowUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ShowUpload.vue?vue&type=style&index=0&id=4021322e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021322e",
  null
  
)

export default component.exports